import {createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {getErrorObjFormat} from "../../../helpers/errorObjFormat";

const url = process.env.REACT_APP_API_BASE_URL + "/v1/auto-charges";

const autoChargesInitialState = {
  autoChargesList: [],
  summary: {},
  isLoading: false,
  error: null,
};

function startLoading(state) {
  state.isLoading = true;
}
function loadingFailed(state, {payload}) {
  state.isLoading = false;
  state.error = payload;
}

const autoCharges = createSlice({
  name: "autoCharges",
  initialState: autoChargesInitialState,
  reducers: {
    getAutoChargesStart: startLoading,
    getAutoChargesSuccess(state, {payload}) {
      state.autoChargesList = payload;
      state.isLoading = false;
      state.error = null;
    },
    getAutoChargesFailure: loadingFailed,
    getAutoChargesSummarySuccess(state, {payload}) {
      state.summary = payload;
    },
  },
});

export const {
  getAutoChargesStart,
  getAutoChargesSuccess,
  getAutoChargesFailure,
  getAutoChargesSummarySuccess,
} = autoCharges.actions;

export default autoCharges.reducer;

export const fetchAutoCharges = status => async (dispatch, getState) => {
  try {
    dispatch(getAutoChargesStart());
    const res = await axios.get(status ? `${url}?status=${status}` : url, {
      headers: {Authorization: `Bearer ${getState().auth.token}`},
    });
    dispatch(getAutoChargesSuccess(res.data.response));
  } catch (err) {
    dispatch(getAutoChargesFailure(getErrorObjFormat(err)));
  }
};

export const fetchAutoChargesSummary = () => async (dispatch, getState) => {
  try {
    const res = await axios.get(`${url}/summary`, {
      headers: {Authorization: `Bearer ${getState().auth.token}`},
    });
    dispatch(getAutoChargesSummarySuccess(res.data.response));
  } catch (err) {
    // The summary only drives the counters above the table - if it fails the
    // table itself is still worth showing, so this does not surface an error.
    dispatch(getAutoChargesSummarySuccess({}));
  }
};
